var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHeatPump(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_795_76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99968 12.4997C11.3804 12.4997 12.4997 11.3805 12.4997 9.99975M9.99968 12.4997C8.61901 12.4997 7.4997 11.3805 7.4997 9.99975M9.99968 12.4997C9.99968 12.4997 11.6567 14.146 11.6667 15.8335C11.6658 17.4943 11.7083 19.1677 10 19.1668C8.37668 19.166 8.33584 17.5202 8.33334 15.8335C8.33084 14.1793 9.99968 12.4997 9.99968 12.4997ZM12.4997 9.99975C12.4997 8.61908 11.3804 7.49975 9.99968 7.49975M12.4997 9.99975C12.4997 9.99975 14.1458 8.3435 15.8333 8.3335C17.4942 8.33433 19.1675 8.29183 19.1667 10.0002C19.1658 11.6235 17.52 11.6643 15.8333 11.6668C14.1792 11.6693 12.4997 9.99975 12.4997 9.99975ZM9.99968 7.49975C8.61901 7.49975 7.4997 8.61908 7.4997 9.99975M9.99968 7.49975C9.99968 7.49975 8.34334 5.85433 8.33334 4.16683C8.33418 2.506 8.29168 0.832663 10 0.833496C11.6233 0.83433 11.6642 2.48016 11.6667 4.16683C11.6692 5.821 9.99968 7.49975 9.99968 7.49975ZM7.4997 9.99975C7.4997 9.99975 5.85418 11.6568 4.16668 11.6668C2.50584 11.666 0.83251 11.7085 0.833344 10.0002C0.834177 8.37683 2.48001 8.336 4.16668 8.3335C5.82084 8.331 7.4997 9.99975 7.4997 9.99975Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_795_76"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeatPump);
export default __webpack_public_path__ + "static/media/icon-heat-pump.a656bb498490cb841efa207c82275ebc.svg";
export { ForwardRef as ReactComponent };